import { render, staticRenderFns } from "./SourceVideoUploader.vue?vue&type=template&id=652ea542&scoped=true&"
import script from "./SourceVideoUploader.vue?vue&type=script&lang=ts&"
export * from "./SourceVideoUploader.vue?vue&type=script&lang=ts&"
import style0 from "./SourceVideoUploader.vue?vue&type=style&index=0&id=652ea542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ea542",
  null
  
)

export default component.exports